import Vue from 'vue';
import * as VeeValidate from 'vee-validate';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { localize, extend } from 'vee-validate';
import {
  required,
  email,
  min,
  max,
  confirmed,
  digits,
  numeric,
  integer,
} from 'vee-validate/dist/rules';
import { store } from '@/store';

// The types of validators used in the project
extend('required', required);
extend('confirmed', confirmed);
extend('email', email);
extend('min', min);
extend('max', max);
extend('numeric', numeric);
extend('integer', integer);
extend('postal_code', digits);
extend('decimal', {
  validate: (value, { decimals = '*', separator = ',' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false,
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`,
    );

    return {
      valid: regex.test(value),
    };
  },
});
extend('url', {
  validate: str => {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ); // fragment locator
    return !!pattern.test(str);
  },
});
extend(
  'shaftTitleUnique',
  (value, [siteId]) => {
    let unique = true;
    store.getters.sites.forEach(site => {
      site.shafts.forEach(shaft => {
        if (site.id === parseInt(siteId) && shaft.title === value)
          unique = false;
      });
    });
    return unique;
  },
  {
    hasTarget: true,
  },
);
extend(
  'passwordsMatch',
  (value, [otherValue]) => {
    return value === otherValue;
  },
  {
    hasTarget: true,
  },
);

const dictionary = {
  messages: {
    email: 'E-Mail ungültig',
    required: 'Pflichtfeld',
    postal_code: 'PLZ erforderlich',
    shaftTitleUnique: 'Schachtbezeichnung auf Baustelle bereits verwendet',
    numeric: 'Nummer erforderlich',
    integer: 'Ganzzahl erforderlich',
    decimal: 'Kommazahl erforderlich',
    passwordsMatch: 'Passwörter stimmen nicht überein',
  },
};

localize('de', dictionary);

Vue.use(VeeValidate);
Vue.component('validationProvider', ValidationProvider);
Vue.component('validationObserver', ValidationObserver);
export default VeeValidate;
